import { faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

function isLastItem(item, items) {
    return items[items.length - 1] === item;
}

function isFirstItem(item, items) {
    return items[0] === item;
}

const Stepper = ({ items, selected, children, onNext, onPrevious }) => {
    const blockPrevious = isFirstItem(selected, items);
    const blockNext = isLastItem(selected, items);

    const enabledChevronClass = 'border-portal-blue-primary cursor-pointer';
    const disabledChevronClass = 'text-gray-400 cursor-not-allowed'

    return (
        <>
            <button
                className={`mx-1 ${blockPrevious ? disabledChevronClass : enabledChevronClass}`}
                disabled={blockPrevious}
                onClick={onPrevious}
                type='button'>
                <FontAwesomeIcon icon={faChevronLeft} />
            </button>
            {children || null}
            <button
                className={`mx-1 ${blockNext ? disabledChevronClass : enabledChevronClass}`}
                disabled={blockNext} onClick={onNext} type='button'>
                <FontAwesomeIcon icon={faChevronRight} />
            </button>
        </>
    );
};

export default Stepper;
